import React from "react";
import logger from "logger";
import AngSelect from "Common/Angular/AngSelect";

const getCityIdForCity = (city) => {
  if (city) {
    const { cityid } = city;
    return cityid;
  }
  return "";
};

export default function(props) {
  const { label, AccountDetailData, setValue, param, taskConfig } = props;
  const [selectedcity, setSelectedcity] = React.useState(
    getCityIdForCity(taskConfig[param])
  );
  logger.log("selectedcity", selectedcity);

  const options = AccountDetailData.heroes.map((city) => {
    logger.log(city);
    const { cityid, cityname } = city;
    return { label: cityname, value: cityid };
  });

  return (
    <>
      <div>
        <span
          style={{ float: "left", marginBottom: "10px", marginTop: "10px" }}
        >
          {label}
        </span>
      </div>
      <div>
        <AngSelect
          placeholder="Select a city"
          ng-model={selectedcity}
          options={options}
          onChange={(event) => {
            logger.log("event", event);
            const value = event.value;
            setSelectedcity(value);
            AccountDetailData.heroes.map((city) => {
              const { cityid } = city;
              if (cityid === value) {
                setValue({ target: { value: city } }, param);
              }
            });
          }}
        />
      </div>
    </>
  );
}
